import { render, staticRenderFns } from "./OnboardingSelfieFacetecCamera.vue?vue&type=template&id=e45f09ce&scoped=true"
import script from "./OnboardingSelfieFacetecCamera.vue?vue&type=script&lang=js"
export * from "./OnboardingSelfieFacetecCamera.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSelfieFacetecCamera.vue?vue&type=style&index=0&id=e45f09ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45f09ce",
  null
  
)

export default component.exports